module.exports = "/images/no-group-large-img.svg?1bad20681cfc3221a44532ac531fad7e";